import { render, staticRenderFns } from "./SdModal.html?vue&type=template&id=89ed0f26&external"
import script from "./SdModal.ts?vue&type=script&lang=ts&external"
export * from "./SdModal.ts?vue&type=script&lang=ts&external"
import style0 from "./SdModal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports